import { anyReallyAny } from "@cervval.js/common/tools";
import { AbstractDataSourceService } from "@ehealth_tools/client-html-tools/src/services/datasourceService/abstractDatasource.service";
import { BOOKING_ADVERTISEMENT_DATA, BOOKING_MODALITY_DATA, BookingDataSourceUID } from "@ehealth_tools/common-booking/src/data/booking.ds";
import { civilities } from "@ehealth_tools/common/src/data/user/user.ds";
import { BookingElementTypes } from "@sportsante/common-shared/src/data/booking/booking.model";
export class AppDataSourceService extends AbstractDataSourceService<BookingElementTypes, keyof BookingElementTypes, BookingDataSourceUID> {

    /** */
    protected override _init(): void {
        super._init();

        // STATICS
        this.registerDataSource<undefined, anyReallyAny>(BookingDataSourceUID.BOOKING_MODALITY, {
            source: {
                data: BOOKING_MODALITY_DATA
            },
            idField: "id",
            labeler: (data) => data.name
        });


        this.registerDataSource<undefined, anyReallyAny>(BookingDataSourceUID.ADVERTISEMENT, {
            source: {
                data: BOOKING_ADVERTISEMENT_DATA
            },
            idField: "id",
            labeler: (data) => data.name
        });

        this.registerDataSource(BookingDataSourceUID.CIVILITY, {
            source: {
                data: civilities
            },
            idField: "id",
            labeler: (data) => data.val
        });

    }
}